import LangEnum from '../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../stores/Snackbar.store';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { WsErrorsStrategy } from '../types/wsErrorsStrategy.type';

export class NonRecognizedExceptionStrategy implements WsErrorsStrategy {
  constructor(private readonly translate: TranslateType) {}

  handle() {
    snackbarStore.handleMessage({
      type: 'error',
      message: this.translate(LangEnum.UNRECOGNIZED_ERROR_IN_WEBSOCKET_CHATS),
    });
  }
}
